import React from 'react';
import SideBar from './category-sidebar';

function RealEstateSideBar(props) {

  let searchLabel = '';

  if (props.isProfilePage) {
    searchLabel = 'Enter Keywords'
  } else {
    searchLabel = 'Enter Keywords or Agency Name'
  }



  return (<SideBar {...props}
    section="realestate"
    searchTitle="Search Properties"
    createNewTitle="New Property"
    filterList={[
      { name: 'keywords', value: searchLabel },
    ]}
  />);
}

export default RealEstateSideBar;